import { IonButton, IonContent, IonModal } from "@ionic/react"
import { Fragment, useState } from "react"
import { User } from "../../../../Common/Interfaces/Entities"
import WeldingSession from "../../../Analytics/Reports/SessionCards/WeldingSession"
import Translate from "../../../../components/Translate"
import { getTranslation } from "../../../../Common/Functions"

const UserSessions: React.FC<{
    sessions: Array<{
        application_id: number
        grade: string
        part: string
        method: string
        session_end: string
        session_id: string
        session_start: string
        time_spent: number
        user_id: number
    }>
    user: User
    setSelectrUser: Function
}> = ({
    sessions,
    user,
    setSelectrUser
}) => {
        const [selectedSession, setSelectedSession] = useState(null)
        const [modal, setModal] = useState(false)
        const [sort, setSort] = useState<string>('session_start')
        const [ascend, setAscend] = useState<number>(-1)
        return (
            <Fragment>
                <IonModal id='session-info-container' trigger="open-modal" isOpen={user !== null} onDidDismiss={e => setSelectrUser(null)}>
                    <IonContent>
                        <div>
                            <div className="flex fixed w-full">
                                <span className="text-center block w-4/12 text-white bg-slate-800 py-2 cursor-pointer" onClick={e => {
                                    setSort("session_start")
                                    if (sort === "session_start") setAscend((ascend * -1))
                                }}><Translate label="Date" /></span>
                                <span className="text-center block w-4/12 text-white bg-slate-800 py-2 cursor-pointer" onClick={e => {
                                    setSort("time_spent")
                                    if (sort === "time_spent") setAscend((ascend * -1))
                                }}><Translate label="Welding Time" /></span>
                                <span className="text-center block w-4/12 text-white bg-slate-800 py-2 cursor-pointer" onClick={e => {
                                    setSort("method")
                                    if (sort === "method") setAscend((ascend * -1))
                                }}><Translate label="Method" /></span>
                                <span className="text-center block w-4/12 text-white bg-slate-800 py-2 cursor-pointer" onClick={e => {
                                    setSort("part")
                                    if (sort === "part") setAscend((ascend * -1))
                                }}><Translate label="Part" /></span>

                            </div>
                            <div className="pt-10">
                                {sessions.sort((a, b) => a[sort] > b[sort] ? 1 * ascend : -1 * ascend).map(session => (
                                    <div className="flex hover:bg-slate-200 cursor-pointer" onClick={e => {
                                        setSelectedSession(session.session_id)
                                        setModal(true)
                                    }}>
                                        <span className="py-2 text-center block w-4/12 text-slate-500 font-bold shadow">{session.session_start.slice(0, 16)}</span>
                                        <span className="py-2 text-center block w-4/12 text-slate-500 font-bold shadow">
                                            {Math.floor(session.time_spent) > 0 ? Math.floor(session.time_spent) + " min" : null} {Math.round((session.time_spent - Math.floor(session.time_spent)) * 60) + " sec"}
                                        </span>
                                        <span className="py-2 text-center block w-4/12 text-slate-500 font-bold shadow">{getTranslation(session.method)}</span>
                                        <span className="py-2 text-center block w-4/12 text-slate-500 font-bold shadow">{getTranslation(session.part)}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="py-4">
                            <IonButton color="primary" className="block w-1/3 mx-auto" onClick={() => setSelectrUser(null)}>
                                Close
                            </IonButton>
                        </div>
                    </IonContent>
                </IonModal>
                <WeldingSession
                    selectedSession={selectedSession}
                    modal={modal}
                    setModal={setModal}
                />
            </Fragment>
        )
    }

export default UserSessions